import { useQuery } from '@tanstack/react-query';

import type { PreflightLoaderData } from '~/routes/__loaders/subscriber_preflight';

type Params = {
  subscriberId: string;
  enabled: boolean;
};

/**
 * Fetches the BE-resolved section-availability flags via the `/preflight`
 * loader. Keyed by subscriber so switching accounts doesn't surface stale tabs.
 */
export const usePreflight = ({ subscriberId, enabled }: Params) =>
  useQuery({
    queryKey: ['preflight', subscriberId],
    queryFn: async (): Promise<PreflightLoaderData> => {
      const response = await fetch('/subscriber_preflight');
      if (!response.ok) {
        throw new Error('Failed to load subscription preflight');
      }
      return response.json();
    },
    enabled,
  });
